<template>
  <div id="app">
    <Component v-if="routeReady" :is="currentFormComponent" />
    <ApiPanel v-if="showApiPanel" :model="store" />
    <!-- <vue-snotify></vue-snotify> -->
  </div>
</template>

<script>
import routeManager from "@/router";
import ApiPanel from "@/forms/components/api-panel";
import store from "@/store";
import {
  SET_QUERYSTRING,
  SET_UTM_SOURCE,
  SET_UTM_MEDIUM,
  SET_UTM_CAMPAIGN,
  SET_UTM_CONTENT,
  SET_UTM_PRODUCT_ID,
  SET_PRODUCT_TYPE,
  SET_PRODCUT_FROM_URL,
  SET_BANK_NAME
} from "@/lib/constants/mutations";
const showPanel = store => {
  const { showApiPanel } = store.state;
  const hideApiPanel = !!process.env.VUE_APP_HIDE_API_PANEL_BY_DEFAULT;
  if (hideApiPanel) {
    return showApiPanel;
  }
  return !!process.env.VUE_APP_API_CALLS;
};

export default {
  components: {
    ApiPanel
  },
  data: () => ({
    showApiPanel: false
  }),

  created() {
    this.showApiPanel = showPanel(this.$store);
    var utm = JSON.parse(JSON.stringify(this.getQueryStringParameters));

    store.commit(SET_UTM_SOURCE, { source: utm.utm_source });
    store.commit(SET_UTM_MEDIUM, { medium: utm.utm_medium });
    store.commit(SET_UTM_CAMPAIGN, { campaign: utm.utm_campaign });
    store.commit(SET_UTM_CONTENT, { content: utm.utm_content });
    store.commit(SET_UTM_PRODUCT_ID, { productId: utm.utm_productId });
    store.commit(SET_QUERYSTRING, {
      querystrings: this.getQueryStringParameters
    });
    store.commit(SET_PRODCUT_FROM_URL, {
      productTypeFromUrl: this.getProductType
    });
    let bankName = this.$store.state.institutions.find(obj => {
      return obj.id === this.fieldValues(FIELD_NAMES.bankAccount);
    });
    if (typeof bankName !== "undefined") {
      store.commit(SET_BANK_NAME, { bankName: bankName.name });
    }
  },

  computed: {
    routeReady: () => routeManager.ready,
    currentFormComponent: () => routeManager.currentFormComponent,
    store() {
      return this.$store;
    },

    getQueryStringParameters() {
      var url = window.location.search;
      var urlParams = {},
        match,
        additional = /\+/g, // Regex for replacing additional symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function(s) {
          return decodeURIComponent(s.replace(additional, " "));
        },
        query;
      if (url) {
        if (url.split("?").length > 0) {
          query = url.split("?")[1];
        }
      } else {
        url = window.location.href;
        query = window.location.search.substring(1);
      }
      while ((match = search.exec(query))) {
        urlParams[decode(match[1])] = decode(match[2]);
      }

      return urlParams;
    },
    getProductType() {
      let url = document.location.href;
      if (url.includes("loan")) {
        return "loan";
      } else if (url.includes("card")) {
        return "card";
      }
      else if (url.includes("protect")) {
        return "insurance";
      }
      // else if (url.includes("executive/referal")) {
      //   return "executive/referal";
      // }
    }
  },
  methods: {}
};
</script>
